export default __webpack_public_path__ + "static/media/Icon-square.b3904e62.svg";